import { allStateCodes, flowStart, stateInfo } from "@/constants/version-state";
import { MermaidGraph } from "@/components/mermaid-graph";

type Flow = Record<string, number[]>;

// Read-only overview of an app's version-state flow, rendered as a mermaid
// flowchart (auto-layout keeps arrows legible however tangled the graph
// gets).
const toMermaid = (flow: Flow) => {
  const codes = allStateCodes().filter((c) => String(c) in flow);
  const lines = ["flowchart LR"];
  // Virtual Start node → the entry state new versions land in.
  lines.push(`  start((Start)) --> s${flowStart(flow)}`);
  for (const c of codes) {
    // Label carries the raw code too — the reference people wire flows by.
    lines.push(`  s${c}["${c} ${stateInfo(c)?.label ?? ""}"]`);
  }
  for (const c of codes) {
    for (const n of flow[String(c)] ?? []) lines.push(`  s${c} --> s${n}`);
  }
  return lines.join("\n");
};

export const VersionFlowGraph = ({ flow }: { flow: Flow }) => (
  <MermaidGraph code={toMermaid(flow)} />
);

export default VersionFlowGraph;
